import { NgModule, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { SigningModule } from '@app/certificates/signing/signing.module';
import { CertificatesRoutingModule } from '@app/certificates/certificates-routing.module';
import { ManageCertificateEffects } from '@app/certificates/manage/manage.effects';
import { MatPaginatorIntl, MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatTableModule } from "@angular/material/table";
import { MatInputModule } from "@angular/material/input";
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatIconModule } from '@angular/material/icon';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ManageService } from '@app/certificates/manage/manage.service';
import { ManageDevicesEffects } from '@app/certificates/devices/devices.effects';
import { DevicesService } from '@app/certificates/devices/devices.service';
import { MainComponent } from '@app/certificates/main/component/main.component';
import { DevicesPageComponent } from '@app/certificates/devices/devices-page/devices-page.component';
import { ManagePageComponent } from '@app/certificates/manage/manage-page/manage-page.component';
import { ManageGridComponent } from '@app/certificates/manage/manage-grid/manage-grid.component';
import { DevicesGridComponent } from '@app/certificates/devices/devices-grid/devices-grid.component';
import { PacksComponent } from './packs/packs.component';
import { ConsentsComponent } from './consents/consents.component';
import { PackItemsComponent } from './packs/pack-items/pack-items.component';
import { PackEffects } from '@app/certificates/packs/packs.effects';
import { HistoryComponent } from './history/history.component';
import { SigningHistoryComponent } from './history/signing-history/signing-history.component';
import { PaginatorIntlTranslator } from '@app/shared/services/paginator-intl.service';
import { PackOrderComponent } from './packs/pack-order/pack-order.component';
import { OrderComponent } from './history/order-history/order-history.component';
import { HistoryService } from '@app/certificates/history/history.service';
import { PackPaymentComponent } from './packs/pack-payment/pack-payment.component';
import { InvoiceFormComponent } from './packs/invoice-form/invoice-form.component';
import { SharedModule } from '@app/shared/modules/shared.module';
import { LocalizedCurrencyPipe } from '@app/shared/pipes/localized-currency-pipe';
import { MatTableHelper } from '@app/shared/helpers/table-filter.helper';
import { LegalTypePipe } from '@app/shared/pipes/legal-type-pipe';
import { EnumToArrayPipe } from '@app/shared/pipes/enum-to-array';
import { CertificateDetailsComponent } from '@app/certificates/manage/certificate-details/certificate-details.component';
import { RevokeConsentComponent } from './consents/revoke-consent/revoke-consent.component';
import { DecodeHtmlStringPipe } from '@app/shared/pipes/decode-html-string';
import { RequestedHistoryComponent } from './history/requested-history/requested-history.component';
import { RequestedHistoryDetailsComponent } from './history/requested-history/requested-history-details/requested-history-details.component';
import { PopupComponent } from './packs/popup/popup/popup.component';

@NgModule({
  imports: [
    MatStepperModule,
    CommonModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatTableModule,
    MatInputModule,
    MatExpansionModule,
    MatSlideToggleModule,
    MatTooltipModule,
    MatIconModule,
    StoreModule,
    SharedModule,
    CertificatesRoutingModule,
    SigningModule,
  ],

  exports: [
    SharedModule,
    StoreModule,
    EffectsModule,
    SigningModule,
    ManagePageComponent,
    HistoryComponent
  ],
  declarations: [
    MainComponent,
    ManagePageComponent,
    ManageGridComponent,
    DevicesPageComponent,
    DevicesGridComponent,
    PacksComponent,
    ConsentsComponent,
    PackItemsComponent,
    HistoryComponent,
    SigningHistoryComponent,
    PackOrderComponent,
    OrderComponent,
    RequestedHistoryComponent,
    PackPaymentComponent,
    InvoiceFormComponent,
    LocalizedCurrencyPipe,
    LegalTypePipe,
    EnumToArrayPipe,
    CertificateDetailsComponent,
    RevokeConsentComponent,
    DecodeHtmlStringPipe,
    RequestedHistoryDetailsComponent,
    PopupComponent
  ],
  entryComponents: [CertificateDetailsComponent, RevokeConsentComponent, RequestedHistoryDetailsComponent],
  providers: [
    ManageService,
    ManageCertificateEffects,
    DevicesService,
    ManageDevicesEffects,
    PackEffects,
    HistoryService,
    MatTableHelper,
    {
      provide: MatPaginatorIntl,
      useClass: forwardRef(() => PaginatorIntlTranslator)
    }
  ]
})
export class CertificatesModule { }
